import { useEffect } from "react";
import HeroSection from "./components/HeroSection";
import EmpresaSection from "./components/EmpresaSection";
import BeneficiosSection from "./components/BeneficiosSection";
import CategoriasSection from "./components/CategoriasSection";
import VehiculosSection from "./components/VehiculosSection";
import ConversionSection from "./components/ConversionSection";
import ContactoSection from "./components/ContactoSection";
import TestimoniosSection from "./components/TestimoniosSection";
import GaleriaSection from "./components/GaleriaSection";
import CTAFinalSection from "./components/CTAFinalSection";
import FooterSection from "./components/FooterSection";
import WhatsAppFloat from "./components/WhatsAppFloat";

export default function HomePage() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <main className="font-sans antialiased">
      <HeroSection />
      <EmpresaSection />
      <BeneficiosSection />
      <CategoriasSection />
      <VehiculosSection />
      <ConversionSection />
      <ContactoSection />
      <TestimoniosSection />
      <GaleriaSection />
      <CTAFinalSection />
      <FooterSection />
      <WhatsAppFloat />
    </main>
  );
}
